/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, useCallback, useContext } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastrContext = createContext();

const ToastrProvider = ({ children }) => {
  const errorResponseHandler = useCallback((data, type = "error", isDirectMsg) => {
    if (type === "success") {
      toast.success(data, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      let errorMessage = "Something went wrong";
      if (data?.response?.data?.message) {
        errorMessage = data?.response?.data?.message ?? "Something went wrong";
      } else if (data?.response?.data?.errors) {
        errorMessage = data?.response?.data?.errors[0]?.msg ?? "Something went wrong";
      }

      if (isDirectMsg) errorMessage = data;

      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, []);

  return (
    <ToastrContext.Provider value={{ errorResponseHandler }}>
      <ToastContainer />
      {children}
    </ToastrContext.Provider>
  );
};

const useToastrContext = () => useContext(ToastrContext);

export { ToastrProvider, useToastrContext };
